import controller from "./header-tabs.controller";
import template from "./header-tabs.html";

export default {
    template,
    controller,
    transclude: true
};
